import styled from "styled-components";
import {
  DialogTitle,
  DialogContent,
  Grid,
  Typography,
  Button,
  DialogActions,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import DragHandleIcon from "@mui/icons-material/DragHandle";

export const SGridContainer = styled(Grid)`
  && {
    width: 375px;
    height: 210px;
    padding: 16px 16px 24px;
    border-radius: 8px;
  }
`;

export const SDialogTitle = styled(DialogTitle)`
  && {
    padding: 0;
    padding-bottom: 24px;
  }
`;

export const STitle = styled(Typography)`
  && {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.alertRed};
    font-weight: 700;
    padding: 0;
  }
`;

export const SCloseButton = styled(IconButton)`
  && {
    position: absolute;
    right: 8px;
    top: 8px;
  }
`;

export const SCloseIcon = styled(CloseIcon)`
  && {
    color: ${({ theme }) => theme.colors.textBlack};
  }
`;

export const SDialogContent = styled(DialogContent)`
  && {
    padding: 0;
    padding-bottom: 24px;
  }
`;

export const SContent = styled(Typography)`
  && {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.textBlack};
  }
`;

export const SDialogActions = styled(DialogActions)`
  && {
    padding: 0;
  }
`;

export const SManualBalanceButton = styled(Button)`
  && {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.textDarkGray};
    text-transform: none;
    white-space: nowrap;
    height: 36px;
    width: 166.5px;

    &:hover {
      background-color: ${({ theme }) => theme.colors.selectedLightBlue};
    }
  }
`;

export const SEditIcon = styled(EditIcon)`
  color: ${({ theme }) => theme.colors.textDark};
  margin-left: 3px;
  padding-left: 6px;
`;

export const SAutoBalanceButton = styled(Button)`
  && {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.textWhite};
    background-color: ${({ theme }) => theme.colors.textDark};
    text-transform: none;
    white-space: nowrap;
    height: 36px;
    width: 166.5px;

    &:hover {
      background-color: ${({ theme }) => theme.colors.addButtonSecondary};
    }
  }
`;

export const SEqualIcon = styled(DragHandleIcon)`
  && {
    color: ${({ theme }) => theme.colors.textWhite};
    margin-left: 3px;
    padding-left: 6px;
  }
`;
